type Errors = {
  invalidChar: string;
  invalidLength: string;
};

type Parsed = {
  isValid: boolean;
  formattedValue: string;
  errorText: string;
};

export function zipCodeValidator(input: string): Parsed {
  const parsed: Parsed = {
    isValid: false,
    formattedValue: "",
    errorText: "",
  };
  const errors: Errors = {
    invalidChar: "ZIP Code should be only numbers",
    invalidLength: "ZIP Code must have 5 or 9 digits",
  };

  let cleanedValue: string = "";
  const zipCode5Pattern: RegExp = /^\d{5}$/;
  const zipCode9Pattern: RegExp = /^(\d{5})-?(\d{4})$/;
  const numberPattern: RegExp = /[0-9]/;
  const allowedPattern: RegExp = /[\W\d]/;

  if (zipCode5Pattern.test(input) || zipCode9Pattern.test(input)) {
    // It's perfect
    parsed.isValid = true;
    parsed.formattedValue = input;

    return parsed;
  }

  // Else it's not perfect, so we check for invalid characters
  if (typeof input === "string" && input.length) {
    for (let i = 0; i < input.length; i += 1) {
      if (numberPattern.test(input[i])) {
        cleanedValue += input[i];
      } else if (!allowedPattern.test(input[i])) {
        parsed.errorText = errors.invalidChar;
        return parsed;
      }
    }
  }

  if (cleanedValue.length !== 5 && cleanedValue.length !== 9) {
    // ZIP Code is incorrect length
    parsed.errorText = errors.invalidLength;

    return parsed;
  }

  // ZIP Code is correct format
  parsed.isValid = true;
  parsed.formattedValue =
    cleanedValue.length === 9
      ? cleanedValue.replace(zipCode9Pattern, "$1-$2")
      : cleanedValue;

  return parsed;
}
